import Vue from "vue";
import Vuex from "vuex";
import { auth ,db,functions} from "../../firebaseconfig";
Vue.use(Vuex);
import router from "../router/index";
import createPersistedState from "vuex-persistedstate";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Echo, platform } from "@/plugins/capacitorPlugin";
import  i18n  from '../plugins/i18n'
import crypto from "crypto"

export default new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['user','templatesLocal','tabsLocal','dictionary','primaryLanguages','languageList','currentLang','salutationArray','signatureArray','showOriginalText'],
  })],
  state: {
    publicPage:'',
    user: "",
    templatesLocal: [],
    tabsLocal: [],
    currentLang: "",
    languageList: [],
    primaryDialog: false,
    primaryLanguages: [],
    dictionary:[],
    showUI:false,
    salutationArray:[],
    signatureArray:[],
    isPremium:false,
    transactionSuccess:false,
    transactionFailure:false,
    showOriginalText:true,
    onlineStatus:true,
    orderId:'',
    paymentLoader:false,
    restoreFailure:false,
    publicPageUrl:''
  },
  mutations: {
    setPublicPageUrl(state,payload){
      state.publicPageUrl=payload
    },
    setSalutationArray(state,v){
     state.salutationArray=v
    },
    setSignatureArray(state,v){
      state.signatureArray=v
    },
    clearVuex(state){
      state.user=''
      state.templatesLocal= []
      state.tabsLocal= []
      state.primaryDialog= false
      state.primaryLanguages= []
      state.showUI=false
      state.salutationArray=[]
      state.signatureArray=[]
      state.isPremium=false
    },
    setUser(state, user) {
      state.user = user;
    },
    setTemplates(state, v) {
      if (v.length > 0) state.templatesLocal = v;
    },
    setTabs(state, v) {
      if (v.length > 0) state.tabsLocal = v
    },
    setCurrentLang(state, v) {
      state.currentLang = v;
      localStorage.setItem('language',v)
    },
    setAllLanguages(state, v) {
      state.languageList = v;
    },
    togglePrimaryDialog(state, v) {
      state.primaryDialog = v;
    },
    setPrimaryLanguages(state, v) {
      state.primaryLanguages = v;
    },
    setDictionary(state,v){
      state.dictionary=v
    },
    setShowUI(state,v){
       state.showUI=v
    },
    setPremium(state, payload) {
      state.isPremium = payload;
    },
    setTransactionSuccess(state,payload){
      state.transactionSuccess=payload
    },
    setTransactionFailure(state,payload){
      state.transactionFailure=payload
    },
    setOriginalText(state,payload){
      state.showOriginalText=payload
    },
    setOnlineStatus(state,payload){
      state.onlineStatus=payload
    },
    setRestoreFailure(state,payload){
      state.restoreFailure=payload
    },
    setPublicPage(state,payload){
      state.publicPage=payload
    },

  },
  actions: {
    checkUserStatus({ commit /*state*/ }) {
      return new Promise((resolve, reject) => {
        auth.onAuthStateChanged(async (user) => {
          if (user) {
            commit("setUser", user);
            resolve(user.uid);
          } else {
            await router.replace("firstPage");
            reject("User is not logged in.");
          }
        });
      });
    },
    async allLanguages(context) {
      const response = await fetch(
        "https://api.cognitive.microsofttranslator.com/languages?api-version=3.0"
      );
      const data = await response.json();
      let array = [];
      let dictionary = data.dictionary;
      context.commit('setDictionary',dictionary)
      for (let key in dictionary) {
        array.push({
          text: `${dictionary[key].name} - ${dictionary[key].nativeName} - ${key}`,
          value: key
        });
      }
      context.commit("setAllLanguages", array);
    },
    async initAnalytics(){
      const firebaseConfig = {
      apiKey: process.env.VUE_APP_FIRE_API_KEY,
      authDomain: process.env.VUE_APP_FIRE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIRE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIRE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIRE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIRE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIRE_APP_ID,
      measurementId: process.env.VUE_APP_FIRE_MEASUREMENT_ID
    };
    await FirebaseAnalytics.initializeFirebase(firebaseConfig);

    },
    async getPremium(context){
      const anonymous =this.state.user.isAnonymous
      if(anonymous) router.push('login');
      else{
      if (platform === "android") {
        const {purchase, isSuccess } = await Echo.echo({ uid: this.state.user.uid });
        if (isSuccess){
          purchase.type=1
        await context.dispatch('upgradePremium',purchase)
          context.commit('setTransactionSuccess',true)

        }else{
          context.commit('setTransactionFailure',true)
          console.log('txn failed');
        }
      }else{
        context.dispatch('restorePurchase',{ upgrade: true })
      }}
    },
    async restorePurchase(context,payload){
      const uid = auth.currentUser.uid;
      db.ref("users").child(uid).child('orderDetails').once("value",(data)=>{
        if(data.exists()){
          const order=data.val();
          this.state.orderId=order.razorpay_order_id;
          context.dispatch('verifySignature',order)

        }else if(payload.upgrade){
          context.dispatch('upgradePremiumRazor')}
          else{
          context.commit('setRestoreFailure',true)
          console.log('no previous data');
        }
      })
    }, async upgradePremiumRazor(context) {
      let amount = 25000;
      let currency = "INR";
      const user =auth.currentUser;
      this.state.paymentLoader=true
      const api_key = process.env.VUE_APP_RAZOR_API_KEY;
      const secret = process.env.VUE_APP_RAZOR_SECRET;
      const company_name = i18n.t('lifetime_premium');
      const description = i18n.t('description_razorpay');
      const name = user.displayName;
      const email = user.email;
      const address = "address";
      const color = "#0745e3";
      let options = {
        send_sms_hash: true,
        readonly: {email: true},
        key_id: api_key,
        key_secret: secret,
        amount: amount, /// The amount is shown in currency subunits. Actual amount is ₹599.
        name: company_name,
        currency: currency, // Optional. Same as the Order currency
        description: description,
        handler: (response) => {
          db.ref("users")
          .child(user.uid)
          .child("orderDetails")
          .set({...response,email});
          context.dispatch("verifySignature", {...response,email});
        },
        modal: {
          handleback:false,
          "ondismiss": function(){
              console.log('Checkout form closed');
          }
      },
        prefill: {
          name: name,
          email: email,
        },
        notes: {
          address: address,
        },
        theme: {
          color: color,
        },
      };
      const data = {
        amount: amount,
        currency: currency,
        receipt: "",
        key: api_key,
        secret: secret,
      };
      //creating order from razorpay api
      const createOrder = functions.httpsCallable("createOrder");
      createOrder(data)
          .then((result) => {
        this.state.orderId = result.data.order.id;
        /* global Razorpay:readonly */
        let razor = new Razorpay({
          ...options,
          order_id: this.state.orderId,
        });
        this.state.paymentLoader=false;
        razor.open();
        razor.on("payment.failed", function(response) {
          console.log(response);
        });
      });
    },
    async verifySignature(context, response) {
      const uid = auth.currentUser.uid;
      this.state.paymentLoader=true
      const orderId= this.state.orderId;
      const paymentId = response.razorpay_payment_id;
      const signarureRp = response.razorpay_signature;
      const email =response.email;
      const secret = process.env.VUE_APP_RAZOR_SECRET;

      const text = orderId + "|" + paymentId;
      const promise= new Promise((resolve, reject)=>{
        const signature = crypto
            .createHmac("sha256", secret)
            .update(text)
            .digest("hex");
        if (signature === signarureRp) {
          console.log("PAYMENT SUCCESSFULL", email);
                const map = {};
                const node = "users/"+uid+"/subscription";
                const nodeRef = db.ref(node);
                const expiryDate = new Date();
                expiryDate.setFullYear(new Date().getFullYear() + 5);
                const historyMap = {
                  id: paymentId,
                  time: expiryDate.getTime(),
                  startTimeMillis: new Date().getTime(),
                  uid: uid,
                  trial: 1,
                  isactive: 1,
                  type: 1,
                };
                map[node+"/id"]= paymentId;
                map[node+"/time"]= expiryDate.getTime();
                map[node+"/startTimeMillis"]= new Date().getTime();
                map[node+"/uid"] = uid;
                map[node+"/trial"]= 1;
                map[node+"/isactive"]= 1;
                map[node+"/type"]= 1;
                map[node+"/history/"+ nodeRef.child("history").
                    push().key]= historyMap;
                return db.ref().update(map)
                    .then(()=>{
                      resolve();
                    })
                    .catch(()=>{
                      reject("data update failed");
                    });
        } else {
          reject("Signature mismatch, wrong order id");
        }
      });
       promise
      .then(() => {
        console.log("Successfully Upgraded User");
        this.state.paymentLoader=false
            context.commit('setTransactionSuccess',true)
      })
      .catch((e) => {
        this.state.paymentLoader=false
        console.log(e);
        context.commit('setTransactionFailure',true)
      });
    },
    async upgradePremium(context,payload){
      const uid=auth.currentUser.uid
      await db.ref('users').child(uid).child('subscription').update(payload).then(()=>{
        console.log('updated successfully');
      }).catch((e)=>{
        console.log('update failed' + e);
      })
    },
    async logTranslationEvent(){
      await FirebaseAnalytics.logEvent({name: 'translation', params: null});
    },
    async logNewTemplateEvent(){
      await FirebaseAnalytics.logEvent({name:'new_template', params: null});
    }
  },

  getters: {
    getUser(state) {
      return state.user;
    },
    getCurrentLang(state) {
      return state.currentLang;
    },
    getAllLanguages(state) {
      return state.languageList;
    },
    getPrimaryDialog(state) {
      return state.primaryDialog;
    },
    getPrimaryLanguages(state) {
      return state.primaryLanguages;
    },
    getDictionary(state) {
      return state.dictionary;
    },
    getShowUI(state){
      return state.showUI
    },
    getSalutationArray(state){
      return state.salutationArray
    },
    getSignatureArray(state){
      return state.signatureArray
    },
    getPremium(state) {
      return state.isPremium;
    },
    getTransactionSuccess(state){
      return state.transactionSuccess
    },
    getTransactionFailure(state){
      return state.transactionFailure
    },
    getOriginalText(state){
      return state.showOriginalText
    },
    getOnlineStatus(state){
      return state.onlineStatus
    },
    getLoader(state){
      return state.paymentLoader;
    },
    getPublicPage(state){
      return state.publicPage;
    },
    getPublicPageUrl(state){
      return state.publicPageUrl
    }

  },

  modules: {},
});
